import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

import { topGBPMinKeys, UKDisableMessage } from '../../../../../../data/ukPrivateCompanyInsights';
import { checkAndRoun } from '../../../../../../helpers/topicsHelpers';
import convertPermalinkToPath from '../../../../../../helpers/urlHelpers';

import Tooltip from '../../../../../Tooltip';
import ConditionalTooltip from '../../../ConditionalTooltip';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const TopInvestors = (props) => {
  const {
    type, hasChanges, hasInsightsAccess, topSectionData, hasInsightsTrialAccess,
    onSort, sortField, sortOrder,
  } = props;
  const [activeTableTab, setActiveTableTab] = useState('investmentsMade');
  const width = useSelector((state) => (
    state.common.width
  ));
  const disableMessage = UKDisableMessage(true);

  const handleTabChange = (value) => {
    setActiveTableTab(value);
  };

  const handleTabClick = (value) => {
    if (width <= 767) {
      handleTabChange(value);
      return;
    }
    onSort(value);
  };

  return (
    <div className={cx('top-sections-outer-holder')}>
      <div className={Styles['top-sections-header']}>
        <div />
        <div
          className={cx('top-sections-header-value', 'investmentsMade', { active: activeTableTab === 'investmentsMade' })}
          onClick={() => handleTabClick('investmentsMade')}
        >
          Number of Investments
          <ConditionalTooltip
            tooltipProps={{
              hasBigScreenDesign: true,
              isCentered: true,
              dynamicPosition: true,
              contentStyle: { left: 0 },
              className: Styles['sort-arrows-tooltip'],
            }}
            tooltipMessage={disableMessage}
            showTooltip={hasInsightsTrialAccess}
          >
            <div className={cx('sort-arrows')}>
              {(sortField !== 'investmentsMade' || sortOrder === 'asc') && (
                <FontAwesomeIcon icon={faCaretUp} className={cx('asc')} />
              )}
              {(sortField !== 'investmentsMade' || sortOrder === 'desc') && (
                <FontAwesomeIcon icon={faCaretDown} className={cx('desc')} />
              )}
            </div>
          </ConditionalTooltip>
        </div>
        <div className={cx('top-sections-header-value', 'currency')} />
        <div
          className={cx('top-sections-header-value', 'valueOfHoldings', { active: activeTableTab === 'valueOfHoldings' })}
          onClick={() => handleTabClick('valueOfHoldings')}
        >
          Value
          <ConditionalTooltip
            tooltipProps={{
              hasBigScreenDesign: true,
              isCentered: true,
              dynamicPosition: true,
              contentStyle: { left: 0 },
              className: Styles['sort-arrows-tooltip'],
            }}
            tooltipMessage={disableMessage}
            showTooltip={hasInsightsTrialAccess}
          >
            <div className={cx('sort-arrows')}>
              {(sortField !== 'valueOfHoldings' || sortOrder === 'asc') && (
                <FontAwesomeIcon icon={faCaretUp} className={cx('asc')} />
              )}
              {(sortField !== 'valueOfHoldings' || sortOrder === 'desc') && (
                <FontAwesomeIcon icon={faCaretDown} className={cx('desc')} />
              )}
            </div>
          </ConditionalTooltip>
          <Tooltip
            newIcon
            className={cx('top-sections-header-tooltip')}
            hasBigScreenDesign
            isCentered
            dynamicPosition
            contentStyle={{ left: 0 }}
          >
            Aggregate value of all private investment reported by the investor.
          </Tooltip>
        </div>
      </div>
      <div className={Styles['top-sections-lists']}>
        {!hasInsightsAccess && (
          <div className={Styles['top-sections-upgrade']}>
            <div className={Styles['top-sections-upgrade-message']}>
              <Link to="/pricing">
                Upgrade to UK Insights
              </Link>
              {' '}
              to use this feature.
            </div>
          </div>
        )}
        {topSectionData.data.map((obj, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`key_${i}`}
            className={cx('top-sections-list', { no_access: !hasInsightsAccess, has_changes: hasChanges })}
          >
            {!hasInsightsAccess ? (
              <div className={Styles['top-sections-list-title']}>
                Company Name
              </div>
            ) : (
              <>
                {obj[topGBPMinKeys[type].urlLink] ? (
                  <Link
                    className={Styles['top-sections-list-title']}
                    to={convertPermalinkToPath(obj[topGBPMinKeys[type].urlLink])}
                  >
                    {obj.name}
                  </Link>
                ) : (
                  <div
                    className={cx('top-sections-list-title', 'no-link')}
                  >
                    {obj.name}
                  </div>
                )}
              </>
            )}
            <div className={cx('top-sections-list-value', 'investmentsMade', { active: activeTableTab === 'investmentsMade' })}>
              {obj.investmentsMade}
            </div>
            <div className={cx('top-sections-list-value', 'currency', { active: activeTableTab === 'valueOfHoldings' })}>
              GBP
            </div>
            <div className={cx('top-sections-list-value', 'valueOfHoldings', { active: activeTableTab === 'valueOfHoldings' })}>
              {checkAndRoun(obj[topGBPMinKeys[type].ytd] || 0, 2, true, true, true)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopInvestors;
